import React from 'react'
import fr from 'assets/i18n/properties_fr.json'
import en from 'assets/i18n/properties_en.json'
import i18n from 'simple-react-i18n'
import { createRoot } from 'react-dom/client'
import App from 'App'

i18n.addLang(fr, ['fr', 'FR'])
i18n.addLang(en, ['en', 'EN'])
i18n.addLang(fr, 'default')
i18n.init()

const container = document.getElementById('app')
const root = createRoot(container)
root.render(
    <App />,
)
